import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import i18next from 'i18next';
import Button from 'react-bootstrap-button-loader';
import styles from '../../../styles/profile.module.css';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';

import { getProfileList, getInfoEmployee } from '../../../actions/myFile/profile';
import { toPhone, toPostalCode } from '../../../utils';
import { withNamespaces } from 'react-i18next';
import { formatDate } from '../../../utils';
import * as storage from '../../../utils/storage'

import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Fab from '@material-ui/core/Fab';
import { isIOS } from '../../../utils';
import EditProfile from './EditProfile';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles((theme) => ({
    firstCell: {
        width: '350px',
        '@media (max-width: 600px)': {
            width: "160px"
        },
        textAlign: 'left',
        float: 'left',
        border: '1px solid red',
    },
    secondCell: {
        width: '350px',
        '@media (max-width: 600px)': {
            width: "65px"
        },
        float: 'left'
    },
    rootProfile: {
        overflow: 'auto',
        padding: '15px'
    },
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    divButtons: {
        textAlign: 'center',
        marginBottom: '10px'
    },
    rootTable: {
        '& td': {
            fontSize: 16,
            '@media (max-width: 600px)': {
                fontSize: 11,
            }
        },
        '& td:first-child': {
            width: '30%',
            '@media (max-width: 600px)': {
                width: '45%'
            }
        },
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const StyledFirstTableCell = withStyles((theme) => ({
    body: {
        fontSize: 16,
        fontWeight: 'bolder',
        '@media (max-width: 600px)': {
            fontSize: 11,
        }
    },
}))(TableCell);

const StyledSecondTableCell = withStyles((theme) => ({
    head: {
        color: '#000000!important',
        fontSize: 16,
        width: '75%',
        '@media (max-width: 600px)': {
            fontSize: 12,
            width: "75%"
        },
        fontWeight: 'bold'
    },
    body: {
        fontSize: 16,
        '@media (max-width: 600px)': {
            fontSize: 11,
        }
    },
}))(TableCell);

function ProfileList(props) {
    const classes = useStyles();

    const [data, setData] = useState([]);
    const [dataEmployee, setDataEmployee] = useState([]);
    const [open, setOpen] = useState(false);
    const [isPending, setIsPending] = useState(props.isPending || false);
    const [isiOS, setIsiOS] = useState(isIOS());

    useEffect(() => {
        loadProfileList();
        resize();
    }, []);

    const resize = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const offSet = 90;

            const customHeight = height - titleBar - offSet;

            const element = document.querySelector('#divProfile');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 0);
    }

    const loadProfileList = () => {
        getProfileList().then(response => {
            response.personalPhone = toPhone(response.personalPhone);
            response.personalCellphone = toPhone(response.personalCellphone);
            response.phoneOffice = toPhone(response.phoneOffice);
            response.corporateCellphone = toPhone(response.corporateCellphone);
            response.pager = toPhone(response.pager);
            response.postalCode = toPostalCode(response.postalCode);
            response.language = response.language === 'F' ? i18next.t('Language:french') : i18next.t('Language:english');

            setIsPending(response.isPending);

            setData(response);
        });
    }

    const loadEmployeeInfo = () => {
        getInfoEmployee().then(response => {
            setDataEmployee(response.dataEmployee);
        });
    }

    const handleReload = () => {
        loadProfileList();
    }

    const handleEdit = () => {
        if (storage.getIsProfileConsultationMode()) {
            return;
        }

        loadEmployeeInfo();
        setOpen(true);
    }

    const handleCloseEdit = () => {
        setOpen(false);
        resize();
    }

    return (
        <div>
            <div id="divProfile" className={styles.detailProfil}>
                <TableContainer className={classes.rootTable} onClick={handleEdit}>
                    <Table className={classes.table} aria-label="spanning table">
                        <TableBody>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.street')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.address1}</StyledSecondTableCell>
                            </TableRow>
                            {data.address2 && <TableRow>
                                <StyledFirstTableCell></StyledFirstTableCell>
                                <StyledSecondTableCell>{data.address2}</StyledSecondTableCell>
                            </TableRow>}
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.city')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.city}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.province')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.province}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.postalCode')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.postalCode}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.personalPhone')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.personalPhone}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.personalCellphone')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.personalCellphone}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.personalEmail')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.personalEmail}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.phoneOffice')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.phoneOffice}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.phoneExtension')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.extensionOffice}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.corporateCellphone')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.corporateCellphone}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.pager')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.pager}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.corporateEmail')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.corporateEmail}</StyledSecondTableCell>
                            </TableRow>
                            <TableRow>
                                <StyledFirstTableCell>{i18next.t('profile:list.language')}</StyledFirstTableCell>
                                <StyledSecondTableCell>{data.language}</StyledSecondTableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <Dialog fullScreen open={open} onClose={handleCloseEdit} TransitionComponent={Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleCloseEdit} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            {i18next.t("profile:title")}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <div className={styles.rootEditProfile}>
                    <EditProfile isPending={isPending} data={data} dataEmployee={dataEmployee} handleReload={handleReload} />
                </div>
            </Dialog>
            {storage.getIsProfileConsultationMode() == false && <Fab color="primary" aria-label="edit" className={`addButtonFabWithBar ${isiOS && "addButtonFabWithBarIOS"}`} onClick={() => handleEdit()} >
                <EditIcon />
            </Fab>}
        </div>
    );
}

export default withNamespaces(['Language', 'profile', 'buttons'], { wait: true })(ProfileList);